import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../../auth/service/utils.service";
import { locale as candidatesIt } from "./i18n/candidates.lang-it";
import recruitmentMenu from "../recruitment.menu";
import candidatesSettingsLinks from "./candidates.settings-list";
import { RouterModule } from "@angular/router";
import candidatesRoutes from "./candidates.routes";
import { CandidateFormComponent } from "./pages/candidate-form/candidate-form.component";
import { CandidateListComponent } from "./pages/candidate-list/candidate-list.component";
import { SuitablesCandidateListComponent } from "./pages/suitables-candidate-list/suitables-candidate-list.component";
import { HiredCandidatesListComponent } from "./pages/hired-candidates-list/hired-candidates-list.component";
import { ContentHeaderModule } from "../../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbTimepickerModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { BreadcrumbModule } from "../../../layout/components/content-header/breadcrumb/breadcrumb.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CandidateRatingsListComponent } from './pages/candidate-ratings-list/candidate-ratings-list.component';
import { LayoutModule } from "../../../layout/layout.module";

@NgModule({
  declarations: [CandidateListComponent, CandidateFormComponent, SuitablesCandidateListComponent, HiredCandidatesListComponent, CandidateRatingsListComponent],
  imports: [
    RouterModule.forChild(candidatesRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    BreadcrumbModule,
    DragDropModule,
    NgbTimepickerModule,
    LayoutModule,
  ],
})
export class CandidatesModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("candidates", candidatesIt, recruitmentMenu, candidatesSettingsLinks);
  }
}
